import React from 'react';

function WebchatSolid(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M19.0938 2.00293C20.0797 2.00293 20.8884 2.76467 20.9631 3.73145L20.9688 3.87793V8.87793C20.9688 9.22311 20.689 9.50293 20.3438 9.50293C20.03 9.50293 19.7702 9.27167 19.7256 8.97029L19.7188 8.87793V7.00293H3.25833V18.0938C3.25833 18.4072 3.48988 18.6673 3.79105 18.712L3.88333 18.7188H8.88333C9.22851 18.7188 9.50833 18.9986 9.50833 19.3438C9.50833 19.6575 9.27707 19.9173 8.97569 19.962L8.88333 19.9688H3.88333C2.89745 19.9688 2.08876 19.207 2.01397 18.2402L2.00833 18.0938V3.87793C2.00833 2.89205 2.77007 2.08336 3.73685 2.00857L3.88333 2.00293H19.0938Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10.7583 16.3784C10.7583 13.2715 13.2765 10.7534 16.3833 10.7534C19.4901 10.7534 22.0083 13.2715 22.0083 16.3784C22.0083 19.4852 19.4901 22.0034 16.3833 22.0034C13.2765 22.0034 10.7583 19.4852 10.7583 16.3784ZM17.0015 13.786C16.9569 13.4846 16.6971 13.2534 16.3833 13.2534C16.0381 13.2534 15.7583 13.5332 15.7583 13.8784V15.7534H13.8833L13.7909 15.7601C13.4896 15.8048 13.2583 16.0646 13.2583 16.3784C13.2583 16.7235 13.5381 17.0034 13.8833 17.0034H15.7583V18.8784L15.7651 18.9707C15.8097 19.2721 16.0695 19.5034 16.3833 19.5034C16.7285 19.5034 17.0083 19.2235 17.0083 18.8784V17.0034H18.8833L18.9757 16.9966C19.277 16.9519 19.5083 16.6922 19.5083 16.3784C19.5083 16.0332 19.2285 15.7534 18.8833 15.7534H17.0083V13.8784L17.0015 13.786Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default WebchatSolid;
